import { Config } from "@config";
import { http } from "bm-ui-kit";
import type { PensionGapLeadCalcRequest, PensionGapLeadCalcResponse } from "../LeadForm/types";
import type { FormFields } from "./PensionGapSmallCalculator";

function getSearchData(values: FormFields): PensionGapLeadCalcRequest {
	return {
		age: values.age,
		income: values.income,
		highestLevelOfEducation: values.highestLevelOfEducation,
		needConsultantCall: values.needConsultantCall,
		preferredProduct: "PENSION",
	};
}

export function calculate(values: FormFields): Promise<PensionGapLeadCalcResponse> {
	const calcRequest: PensionGapLeadCalcRequest = getSearchData(values);

	return http.post(Config.getApiUrl("/api/public/pension2/pension-gap/calculate"), calcRequest);
}
